import styled from '@emotion/styled';

export const TabsContainer = styled.div`
  // Ряд не помещается (вкладки турнира на 1024) — прокручивается вбок, а не переносится и не сжимает подписи:
  // подписи кнопок в одну строку (IMGM-1610), ряд вкладок в две строки не читается (GitLab Pajamas, Tabs).
  // overflow срезает кольцо фокуса крайних вкладок — поле 4px внутри, компенсированное отрицательным margin.
  // Полоса тонкая, но видимая: скрытая не подсказывает мышью, что вкладок больше.
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 4px;
  margin: -4px;

  & .control {
    margin-right: 16px;
  }
  & .control:last-child {
    margin-right: 0;
  }

  & .arrow {
    &.active {
      display: none;
    }
  }
`;
